import React from 'react'
import get from 'lodash/get'
import TalksFramework from '../../components/TalksFramework'
import PresenterScreen from '../../components/PresenterScreen'
import PresenterActions from '../../components/PresenterActions'
import SidePanelContent from '../../components/SidePanelContent'
import LiveSupportWidget from '../../components/LiveSupportWidget'
import PresenterModalManager from '../../components/PresenterModalManager'
import MediaDrawerCollection from '../../components/MediaDrawerCollection'
import ErrorBoundary from '@bt-react/components/ErrorBoundary'
import NotificationsManager from '../../components/Notifications'
import QualityWarning from '../../components/QualityWarning'
import { PresenterProps } from './types'
import PresenterSidePanelMenu from '../../components/PresenterSidePanelMenu'
import PresenterBar from '../../components/PresenterBar'

class Presenter extends React.Component<PresenterProps> {

  componentDidMount () {
    
    window.addEventListener('keydown', this.preventSpaceEvent)
    const roomname = get(this.props, 'match.params.roomname', '')
    const search = get(this.props, 'location.search', '')

    if (!this.props.isPresentReady) this.props.history.replace(`/${roomname}${search}`)
    if (this.props.hasGigEnded) this.props.history.replace(`/end/${roomname}`)

  }

  componentDidUpdate () {

    if (this.props.hasGigEnded) this.props.history.replace(`/end/${get(this.props.match.params, 'roomname')}`)

  }

  componentWillUnmount () {

    window.removeEventListener('keydown', this.preventSpaceEvent)

    if (this.props.hasGigEnded)  this.props.endAllVotes()

  }

  preventSpaceEvent = (event) => {

    if (event.code === 'Space' && event.target instanceof Element && !['TEXTAREA', 'INPUT'].includes(event.target.nodeName)) {

      event.preventDefault()

    }

  }

  render () {

    if (!this.props.isPresentReady) return null

    return <>
        <ErrorBoundary>
          <LiveSupportWidget />
        </ErrorBoundary>
        <NotificationsManager />
        {this.props.qualityWarning && <QualityWarning text={this.props.qualityWarning} onCloseClick={this.props.onQualityWarningClose} />}
        <TalksFramework
          isWarningActive={!!this.props.qualityWarning}
          actionNav={<PresenterActions />}
          content={
            <>
                <PresenterScreen />
              <MediaDrawerCollection />
            </>
          }
          isSidePanelOpen={this.props.isSidePanelOpen}
          presenterBar={<PresenterBar />}
          sidebarNav={<PresenterSidePanelMenu />}
          sidePanelContent={<SidePanelContent menuItemSelected={this.props.menuItemSelected}/>}
        />
        <PresenterModalManager />
    </>

  }

}

export default Presenter
